export const groupNameMapping = {
    "none": "None",
    "author-company": "Author Company",
    "author": "Author",
    "organisation": "Stock",
    "organisation-region": "Stock Region",
    "author-region": "Author Region",
    "author-function": "Author Role",
    "market-cap": "Market Cap",
    "sector": "Sector"
};

export function formatGroupName(groupName) {
    if (groupNameMapping[groupName]) {
        return groupNameMapping[groupName];
    } else {
        throw new Error(`Unable to format group name ${groupName} for grouping widget`);
    }
}